import DesktopTable from './DesktopTable';

export default DesktopTable;
